import { HeaderData } from "../types/dataType";
import { isMobile } from "../utils/commonUtils";

export const COOKIE_MAX_AGE = 86400 * 30 * 1000;
export const USER_ID_IN_COOKIE_KEY = "userId";
export const MESSAGE_FOR_NOT_ALLOWED_SITE =
    "You are not allowed to access this site. Please contact the administrator at admin@pascall.systems for more information.";
export const TIME_TO_AUTO_CLOSE_ALERT_IN_MS = 4000;
export const APP_URLS = {
    DASHBOARD: "dashboard",
    SOP_REVIEW: "sop-review",
    TRAINING_COMPETENCY: "training-competency",
    SIGN_IN: "login",
    SIGN_IN_CALLBACK: "auth/callback",
    MS_SIGN_IN_CALLBACK: "auth/ms-callback",
    TRAINING_MANAGEMENT: "training-management",
    CAPA_MANAGEMENT: "capa-management",
    PURCHASE_ACCEPTANCE: "purchase-acceptance",
    NONCONFORMANCE_AND_INVESTIGATION: "nonconformance-and-investigation",
    INTERNAL_AUDIT: "internal-audit",
    MANAGEMENT_REVIEWS: "management-reviews",
    DEVICE_MANAGEMENT: "device-management",
    NUMBER_OF_CREATED_AND_RESOLVED: "number-of-created-and-resolved",
};

export const APP_COLORS = {
    PASSED: "#52c41a",
    FAILED: "#f5222d",
    ASSIGNED: "#faad14",
    TOTAL: "#1C62F0",
};

export const APP_STATUSES = {
    PASSED: "Passed",
    FAILED: "Failed",
    ASSIGNED: "Assigned",
    TOTAL: "Total Assigned",
};

export const APP_QUARTERS = {
    FIRST: "1st",
    SECOND: "2nd",
    THIRD: "3rd",
    FOURTH: "4th",
};
export const VIEW_MODES = {
    DETAILED: "detail",
    TABLE: "table",
};

export const BLANK_STRING = "";

export const PAGE_DESIGN_WIDTH_IN_PIXEL_IN_WEB_MODE = 1920;
export const PAGE_DESIGN_WIDTH_IN_MOBILE_MODE = 704;
export const PAGE_DESIGN_WIDTH_IN_PIXEL = isMobile() ? PAGE_DESIGN_WIDTH_IN_MOBILE_MODE : PAGE_DESIGN_WIDTH_IN_PIXEL_IN_WEB_MODE;

export const POPUP_CLASS = "log-table-popup";

export const DEFAULT_ITEMS_PER_PAGE = 100;
export const SPACES_CODE = ["M1", "QMS", "M0FDA", "QMSFIL", "M0", "TV"];
export const SORT_BY_DATE_CODES = ["DCR", "TRC", "L4-EM", "L4-ECR", "L4-DCR", "L4-TRC"];

export const VERSION_COLUMN_HEADER = "Latest Version";
export const TABLE_HEADER_FIELDS: HeaderData[] = [
    {
        text: "",
        width: 5,
        dataField: "rowIndex",
    },
    {
        dataField: "documentCode",
        text: "Document Code",
        width: 10,
        sort: true,
    },
    {
        dataField: "documentName",
        text: "Document Name",
        width: 45,
        sort: true,
    },
    {
        text: VERSION_COLUMN_HEADER,
        width: 10,
        dataField: "latestVersion",
    },
    {
        dataField: "effectiveOn",
        text: "Effective on",
        width: 10,
        sort: true,
        isSortByDate: true,
    },
    {
        dataField: "effectiveRevision",
        text: "Effective Revision",
        width: 10,
    },
    {
        dataField: "latestVersion",
        text: "Latest Revision",
        width: 10,
    },
];

export const TABLE_HEADER_FIELDS_WITH_REVIEW_DATE = [
    {
        dataField: "rowIndex",
        text: "",
        width: 5,
    },
    {
        dataField: "documentCode",
        text: "Document Code",
        width: 8,
        sort: true,
    },
    {
        dataField: "documentName",
        text: "Document Name",
        width: 40,
        sort: true,
    },
    {
        dataField: "latestVersion",
        text: VERSION_COLUMN_HEADER,
        width: 8,
    },
    {
        dataField: "effectiveOn",
        text: "Effective on",
        width: 10,
        sort: true,
        isSortByDate: true,
    },
    {
        dataField: "reviewDate",
        text: "Review Date",
        width: 10,
        sort: true,
        isSortByDate: true,
    },
    {
        dataField: "effectiveRevision",
        text: "Effective Revision",
        width: 8,
    },
    {
        dataField: "latestVersion",
        text: "Latest Revision",
        width: 8,
    },
];

export const TABLE_HEADER_FIELDS_WITH_OPEN_DATE = [
    {
        text: "",
        width: 5,
        dataField: "rowIndex",
    },
    {
        dataField: "documentCode",
        text: "Document Code",
        width: 8,
        sort: true,
    },
    {
        dataField: "documentName",
        text: "Document Name",
        width: 40,
        sort: true,
    },
    {
        dataField: "latestVersion",
        text: VERSION_COLUMN_HEADER,
        width: 8,
    },
    {
        dataField: "effectiveOn",
        text: "Effective on",
        width: 10,
        sort: true,
        isSortByDate: true,
    },
    {
        dataField: "openDate",
        text: "Open Date",
        width: 10,
        sort: true,
        isSortByDate: true,
    },
    {
        dataField: "effectiveRevision",
        text: "Effective Revision",
        width: 8,
    },
    {
        dataField: "latestVersion",
        text: "Latest Revision",
        width: 8,
    },
];

export const TABLE_HEADER_FIELDS_WITH_REVIEW_DATE_AND_OPEN_DATE = [
    {
        text: "",
        width: 4,
        dataField: "rowIndex",
    },
    {
        dataField: "documentCode",
        text: "Document Code",
        width: 8,
        sort: true,
    },
    {
        dataField: "documentName",
        text: "Document Name",
        width: 40,
        sort: true,
    },
    {
        dataField: "latestVersion",
        text: VERSION_COLUMN_HEADER,
        width: 8,
    },
    {
        dataField: "effectiveOn",
        text: "Effective on",
        width: 10,
        sort: true,
    },
    {
        dataField: "openDate",
        text: "Open Date",
        width: 10,
        sort: true,
    },
    {
        dataField: "reviewDate",
        text: "Review Date",
        width: 10,
        sort: true,
    },
    {
        dataField: "effectiveRevision",
        text: "Effective Revision",
        width: 7,
    },
    {
        dataField: "latestVersion",
        text: "Latest Revision",
        width: 7,
    },
];

export const DOCUMENT_VERSION_TABLE_TITLE = "Document's Version";
export const VERSION_TABLE_TITLE = "Version";
export const COLUMN_WIDTH = TABLE_HEADER_FIELDS.map((item) => item.width);
export const COLUMN_WIDTH_WITH_REVIEW_DATE = TABLE_HEADER_FIELDS_WITH_REVIEW_DATE.map((item) => item.width);
export const COLUMN_WIDTH_WITH_REVIEW_DATE_AND_OPEN_DATE = TABLE_HEADER_FIELDS_WITH_REVIEW_DATE_AND_OPEN_DATE.map((item) => item.width);
export const OBSOLETE = "OBSOLETE";
export const OBSOLETE_WITH_BRACKET_SQUARE = "[OBSOLETE]";
export const COMMAND = "JQL:";

export const CENTER_HEADER = ["Latest Version", "Effective Revision", "Latest Revision"];
export const COPY_TABLE_BUTTON_TEXT = "Copy Table";
export const COPY_TABLE_BUTTON = "copy-table-button";
export const LOG_TABLE_ID = "log-table";
export const BUTTON_COPY_AND_SEARCH_WRAPPER = "button-copy-and-search-wrapper";

export const OUT_OF_SERVICE_STATUS = "Out of service";
export const NA_CALIBRATION_DATE = ["N/A", "NA", "N.A"];

export const EXPORT_REPORT_BUTTON_TEXT = "Export Report";
export const EXPORT_REPORT_BUTTON = "export-report-button";
